export default __webpack_public_path__ + "static/media/avatar.c9a57026.png";